import React, { useState}  from "react";
import { useNavigate } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { commonStyles } from "../AuthenticationLayout/authenticationLayoutCommonStyling.tailwind";
import { signUp, signUpWithoutOtp } from "../../redux/slices/authSlice";
import signUpValidationSchema from "./signup.validation";
import Button from "../shared/Button/Button";
import routeConstant from "../../lib/constants/routeConstant";
import { VIA_EMAIL } from "../../lib/constants/globalConstant.js";
import pathConstant from "../../lib/constants/pathConstant.js";
import { phoneNumberRegex } from "../../lib/constants/regexConstant.js";
import PhoneAndEmailField from "../shared/Input/PhoneAndEmailField/PhoneAndEmailField.jsx";
import GoogleAuth from "../shared/Button/googleAuthButton.jsx";
// import Checkbox from '../shared/Input/Checkbox/Checkbox.jsx';
import OverlayLoader from "../shared/Loaders/OverlayLoader/OverlayLoader.jsx";

const SignUpForm = ({ getSignedUp }) => {
  const navigate = useNavigate();

  // controller and state handled by react-hook-form
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(signUpValidationSchema), // Use Yup resolver
  });

  // redux-selectors
  const { isLoading: isSigning } = useSelector(state => state.auth)
  const { loggingWithGoogle } = useSelector(state => state.googleAuth)

  // Watch the input value
  const inputValue = useWatch({ control, name: "value" }) || "";
  const [isPhoneInputVisible, setIsPhoneInputVisible] = useState(phoneNumberRegex.test(inputValue));

  
  // handle Signup user
  const signUpUser = async (formData) => {
    /* state has been passed so that the redirection to the next page can be handled accordingly. And the data 
       can be fetched from the state and sent to the api */
    const state = {
      stateValue: isPhoneInputVisible ? `+${formData.value}` : formData.value,
      loginViaMethod: isPhoneInputVisible ? VIA_EMAIL.PHONE_NUMBER : VIA_EMAIL.EMAIL,
      from: pathConstant[routeConstant.SIGNUP_PAGE]
    }

    // data passed to api
    const data = isPhoneInputVisible
    ? {
        phoneNumber: `+${formData.value}`, // If phone, send it as `phoneNumber`
        viaEmail: VIA_EMAIL.PHONE_NUMBER,
        // textAlertPreference: formData.receiveNotifications
      }
    : {
        email: formData.value, // If email, send it as `email`
        viaEmail: VIA_EMAIL.EMAIL, 
        // textAlertPreference: formData.receiveNotifications
      };
    // dispatch signup
    const resultAction = await getSignedUp(data);
    if (signUpWithoutOtp.fulfilled.match(resultAction)) {
      //FOR DEMO
      // navigate(`${routeConstant.VERIFY_OTP_PAGE}`, { state }); // Redirect to select-sport after login
      navigate(`${routeConstant.CREATE_PASSWORD_PAGE}`, {state: { validate: true }}); 
    }
  }

  return (
    <div className={commonStyles.sub_container}>
      {(loggingWithGoogle || isSigning) && <OverlayLoader />}
      <form className={`${commonStyles.form_wrpr} !gap-[30px]`} onSubmit={handleSubmit(signUpUser)}>
        {/* Email or Phone Number Input componet handled by PhoneAndEmailField */}
        <PhoneAndEmailField
            name="value"
            control={control}
            setValue={setValue}
            inputValue={inputValue}
            isPhoneInputVisible={isPhoneInputVisible}
            setIsPhoneInputVisible={setIsPhoneInputVisible}
            error={!!errors.value}
            helperText={errors.value?.message}
        />

        {/* Opt-in Checkbox */}
        {/* <div className="flex items-start gap-2">
          <input type="checkbox" id="opt-in" name="opt-in" className={'mt-2'} />
          <span>
            I opt in to receive notifications about my account by text messages and emails.
          </span>
        </div> */}
        {/* <Checkbox 
          name="receiveNotifications"
          control={control}
          label="I opt in to receive notifications about my account by text messages and emails."
          color="#0AA4D5"
          defaultValue={0}
        /> */}

        {/* Signup Button */}
        <Button variant="primary" type="submit" className={commonStyles.loginButton} disabled={isSigning}>
          {isSigning ? `Creating...` : `Create Account`}
        </Button>
      </form>

      {/* Bottom-Divider/Content */}
      <div className={commonStyles.bottom_cntnt}>
        {/* Divider with "or" */}
        <div className={commonStyles.orContainer}>
          <div className={commonStyles.orLines}></div> {/* Line before "or" */}
          <span>or</span> {/* Centered "or" */}
          <div className={commonStyles.orLines}></div> {/* Line after "or" */}
        </div>

        {/* Sign Up with Google Button */}
        <GoogleAuth text="Sign Up with Google" />
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  //FOR DEMO CHANGE signUpWithoutOtp To signUp
  getSignedUp: (data) => dispatch(signUpWithoutOtp(data)),
});

export default connect(null, mapDispatchToProps)(SignUpForm);